var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isWorkspaceSuggest
    ? _c("WorkspaceFolderTree", {
        class: {
          "workspace-suggestion-hidden": !_vm.showWorkspaceSuggest,
        },
        attrs: { service: _vm.workspaceFolderTreeService },
        nativeOn: {
          mousedown: function ($event) {
            return function (event) {
              return _vm.preventDefaultEvent(event)
            }.apply(null, arguments)
          },
        },
      })
    : _vm.isCustomField
    ? _c("CustomFieldsModal", {
        attrs: {
          loading: _vm.customFieldValueLodading,
          title: _vm.customFieldSuggestTitle,
          type: _vm.customFieldType,
          list: _vm.customFieldValue,
          stem: _vm.customFieldStem,
        },
        on: { onSelect: _vm.onSelectCustomField },
        nativeOn: {
          mousedown: function ($event) {
            return function (event) {
              return _vm.preventDefaultEvent(event)
            }.apply(null, arguments)
          },
        },
      })
    : _c("SuggestionBoard", {
        attrs: {
          "default-status": _vm.isDefaultStatus,
          suggestion: _vm.suggestionList,
          "selected-index": _vm.dropData.selectIndex,
          "analytics-domain": _vm.analyticsDomain,
          "stem-keyword": _vm.stem,
        },
        on: {
          "update-selected-index": _vm.updateSelectedIndex,
          select: function (ref) {
            var index = ref.index

            return _vm.selectOption(_vm.SELECT_OPTIONS_SELECTED, index)
          },
          "select-query": _vm.handleSelectQuery,
        },
      })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }